/* Noctimoth theme JS — no dependencies */
(() => {
  const N = window.Noctimoth || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const fmt = N.moneyFormat || '€{{amount_with_comma_separator}}';
    const v = (Number(cents) || 0) / 100;
    const fix = (n, d, ts, ds) => {
      const parts = n.toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts.join(ds);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount': return fix(v, 2, ',', '.');
        case 'amount_no_decimals': return fix(v, 0, ',', '.');
        case 'amount_with_comma_separator': return fix(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fix(v, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fix(v, 2, "'", '.');
        default: return fix(v, 2, ',', '.');
      }
    });
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const t = $('#Toast');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { t.hidden = true; }, 2800);
  }

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(() => {
      d.classList.add('is-open');
      document.body.classList.add('is-locked');
      const f = d.querySelector('[data-autofocus]') || d.querySelector('button, a, input');
      if (f) setTimeout(() => f.focus({ preventScroll: true }), 50);
    });
    $$(`[aria-controls="${id}"]`).forEach(b => b.setAttribute('aria-expanded', 'true'));
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    $$(`[aria-controls="${d.id}"]`).forEach(b => b.setAttribute('aria-expanded', 'false'));
    setTimeout(() => { if (!d.classList.contains('is-open')) d.hidden = true; }, 360);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      if (opener.dataset.openDrawer === 'CartDrawer' && N.cartType !== 'drawer') return;
      e.preventDefault();
      openDrawer(opener.dataset.openDrawer);
      return;
    }
    const closer = e.target.closest('[data-close-drawer]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const open = $('.drawer.is-open');
    if (open) closeDrawer(open);
    const s = $('#SearchModal');
    if (s && !s.hidden) closeSearch();
  });
  /* swipe to close drawers on touch */
  $$('.drawer').forEach(d => {
    let x0 = null;
    const panel = d.querySelector('.drawer__panel');
    if (!panel) return;
    panel.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    panel.addEventListener('touchend', e => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if ((d.classList.contains('drawer--right') && dx > 70) || (d.classList.contains('drawer--left') && dx < -70)) closeDrawer(d);
      x0 = null;
    }, { passive: true });
  });

  /* ---------- Announcement ---------- */
  $$('[data-announcement]').forEach(bar => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4200);
  });

  /* ---------- Search ---------- */
  const searchModal = $('#SearchModal');
  function openSearch() {
    if (!searchModal) return;
    searchModal.hidden = false;
    document.body.classList.add('is-locked');
    const i = $('input[type=search]', searchModal);
    setTimeout(() => i && i.focus(), 30);
  }
  function closeSearch() {
    if (!searchModal) return;
    searchModal.hidden = true;
    document.body.classList.remove('is-locked');
  }
  document.addEventListener('click', e => {
    if (e.target.closest('[data-open-search]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-close-search]')) { e.preventDefault(); closeSearch(); }
  });
  if (searchModal) {
    const input = $('input[type=search]', searchModal);
    const out = $('[data-predictive]', searchModal);
    const suggest = $('[data-suggest]', searchModal);
    let ctrl, timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; if (suggest) suggest.hidden = false; return; }
      timer = setTimeout(async () => {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        try {
          const url = `${N.routes.predictiveSearch}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6`;
          const res = await fetch(url, { signal: ctrl.signal });
          const data = await res.json();
          const products = (data.resources && data.resources.results.products) || [];
          const cols = (data.resources && data.resources.results.collections) || [];
          if (suggest) suggest.hidden = true;
          if (!products.length && !cols.length) {
            out.innerHTML = `<p class="small" style="text-align:center;padding:20px">Nothing found for “${escapeHtml(q)}”. Try moth, skull or choker.</p>`;
            return;
          }
          out.innerHTML = cols.map(c => `<a class="predictive__item" href="${c.url}"><span><span class="eyebrow">Collection</span><span>${escapeHtml(c.title)}</span></span></a>`).join('') +
            products.map(p => `<a class="predictive__item" href="${p.url}">${p.featured_image && p.featured_image.url ? `<img src="${p.featured_image.url}&width=120" alt="" loading="lazy" width="56" height="56">` : ''}<span><span>${escapeHtml(p.title)}</span><span class="predictive__price">${formatMoney(Math.round(parseFloat(p.price) * 100))}</span></span></a>`).join('') +
            `<a class="btn btn--ghost btn--block" style="margin-top:12px" href="${N.routes.search}?q=${encodeURIComponent(q)}&type=product">View all results</a>`;
        } catch (err) { /* aborted */ }
      }, 220);
    });
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

  /* ---------- Cart ---------- */
  async function refreshCartDrawer(sectionsHtml) {
    let html = sectionsHtml && sectionsHtml['cart-drawer'];
    if (!html) {
      const r = await fetch(`${N.routes.root}?sections=cart-drawer`);
      const j = await r.json();
      html = j['cart-drawer'];
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-inner]');
    const cur = $('[data-cart-inner]');
    if (fresh && cur) cur.replaceWith(fresh);
    const count = doc.querySelector('[data-cart-count-source]');
    if (count) updateCount(count.dataset.cartCountSource);
  }
  function updateCount(n) {
    $$('[data-cart-count]').forEach(el => { el.textContent = Number(n) > 0 ? n : ''; el.dataset.count = n; });
  }
  async function addToCart(form, btn) {
    const fd = new FormData(form);
    if (N.cartType === 'drawer') fd.append('sections', 'cart-drawer');
    btn && btn.classList.add('is-loading');
    try {
      const res = await fetch(`${N.routes.cartAdd}.js`, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      const data = await res.json();
      if (!res.ok || data.status) { toast(data.description || data.message || 'This piece could not be added.'); return; }
      if (N.cartType === 'drawer') {
        await refreshCartDrawer(data.sections);
        openDrawer('CartDrawer');
      } else {
        window.location.href = N.routes.cart;
      }
    } catch (e) {
      form.submit();
    } finally {
      btn && btn.classList.remove('is-loading');
    }
  }
  document.addEventListener('submit', e => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    if (N.cartType !== 'drawer' && !form.hasAttribute('data-quick')) return;
    e.preventDefault();
    addToCart(form, e.submitter || form.querySelector('[type=submit]'));
  });
  async function changeLine(key, quantity) {
    const body = { id: key, quantity, sections: 'cart-drawer' };
    const res = await fetch(`${N.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await res.json();
    if (!res.ok || data.status) { toast(data.description || data.message || 'Could not update your bag.'); }
    if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
    await refreshCartDrawer(data.sections);
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-line-qty]');
    if (b) {
      e.preventDefault();
      const item = b.closest('[data-line]');
      const input = item.querySelector('input[data-line-input]');
      const next = Math.max(0, Number(input.value) + Number(b.dataset.lineQty));
      input.value = next;
      item.style.opacity = .5;
      changeLine(item.dataset.line, next);
      return;
    }
    const r = e.target.closest('[data-line-remove]');
    if (r) {
      e.preventDefault();
      const item = r.closest('[data-line]');
      item.style.opacity = .5;
      changeLine(item.dataset.line, 0);
    }
  });
  document.addEventListener('change', e => {
    const input = e.target.closest('input[data-line-input]');
    if (!input) return;
    const item = input.closest('[data-line]');
    changeLine(item.dataset.line, Math.max(0, Number(input.value)));
  });

  /* ---------- Quantity selectors (product) ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    input.value = Math.max(1, Number(input.value || 1) + Number(b.dataset.qtyStep));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product ---------- */
  $$('[data-product]').forEach(root => {
    const dataEl = root.querySelector('[data-variants-json]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const form = root.querySelector('form[data-product-form]');
    const idInput = form.querySelector('input[name=id]');
    const btn = form.querySelector('[data-atc]');
    const priceEl = root.querySelector('[data-price]');
    const saveEl = root.querySelector('[data-save]');
    const stockEl = root.querySelector('[data-stock]');
    const lowT = Number(root.dataset.lowStock || 0);
    const track = root.querySelector('.gallery__track');
    const sticky = document.querySelector('[data-sticky-atc]');

    const selected = () => $$('fieldset[data-option]', root).map(fs => {
      const c = fs.querySelector('input:checked');
      return c ? c.value : null;
    });

    function markAvailability(sel) {
      $$('fieldset[data-option]', root).forEach((fs, idx) => {
        $$('input', fs).forEach(inp => {
          const test = sel.slice(); test[idx] = inp.value;
          const ok = variants.some(v => v.available && v.options.every((o, i) => i > idx ? true : o === test[i]));
          inp.classList.toggle('is-unavailable', !ok);
        });
        const lab = fs.querySelector('legend span');
        const c = fs.querySelector('input:checked');
        if (lab && c) lab.textContent = c.value;
      });
    }

    function update() {
      const sel = selected();
      const v = variants.find(v => v.options.every((o, i) => o === sel[i]));
      markAvailability(sel);
      if (!v) {
        btn.disabled = true; btn.textContent = 'Unavailable';
        if (sticky) { const sb = sticky.querySelector('button'); sb.disabled = true; sb.textContent = 'Unavailable'; }
        return;
      }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.label : 'Sold out';
      if (priceEl) {
        const sale = true;
        priceEl.classList.toggle('price--sale', sale);
        priceEl.innerHTML = `<span class="price__now">${formatMoney(v.price)}</span>` + (sale ? `<s class="price__compare">${formatMoney(v.price * 2)}</s>` : '');
        if (saveEl) {
          saveEl.hidden = !sale;
          if (sale) saveEl.textContent = `Save ${50}%`;
        }
      }
      if (stockEl) {
        stockEl.className = 'stock';
        if (!v.available) { stockEl.classList.add('stock--out'); stockEl.textContent = 'Sold out — check back soon'; }
        else if (v.managed && v.qty > 0 && v.qty <= lowT) { stockEl.classList.add('stock--low'); stockEl.textContent = `Only ${v.qty} left — almost gone`; }
        else { stockEl.textContent = 'In stock, ready to ship'; }
      }
      if (v.media && track) {
        const slide = track.querySelector(`[data-media-id="${v.media}"]`);
        if (slide && window.innerWidth < 990) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      if (sticky) {
        const sb = sticky.querySelector('button');
        sb.disabled = !v.available;
        sb.textContent = v.available ? sb.dataset.label : 'Sold out';
        const sp = sticky.querySelector('[data-sticky-price]');
        if (sp) sp.textContent = formatMoney(v.price);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.addEventListener('change', e => { if (e.target.closest('fieldset[data-option]')) update(); });
    if ($$('fieldset[data-option]', root).length) markAvailability(selected());

    /* gallery dots */
    if (track) {
      const dots = $$('.gallery__dots button', root);
      dots.forEach((d, i) => d.addEventListener('click', () => {
        const s = track.children[i]; if (s) track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
      }));
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach((d, j) => d.setAttribute('aria-current', j === i ? 'true' : 'false'));
        });
      }, { passive: true });
    }

    /* sticky add to cart on mobile */
    if (sticky && btn && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([en]) => {
        sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
      io.observe(btn);
      sticky.querySelector('button').addEventListener('click', () => {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(btn); else btn.click();
      });
    }
  });

  /* ---------- Collection filters & sort ---------- */
  $$('[data-filter-form]').forEach(form => {
    form.addEventListener('change', e => {
      if (e.target.matches('input[type=number]')) return;
      submitFilters(form);
    });
    form.addEventListener('submit', e => { e.preventDefault(); submitFilters(form); });
  });
  function submitFilters(form) {
    const params = new URLSearchParams(new FormData(form));
    for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
    const sort = $('[data-sort]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    window.location.search = params.toString();
  }
  $$('[data-sort]').forEach(sel => sel.addEventListener('change', () => {
    const params = new URLSearchParams(window.location.search);
    params.set('sort_by', sel.value);
    params.delete('page');
    window.location.search = params.toString();
  }));

  /* ---------- Newsletter / forms: keep focus on success ---------- */
  $$('[data-scroll-on-load]').forEach(el => el.scrollIntoView({ block: 'center' }));
})();
